import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { RootState, setCurrentUserCampus, setCurrentUserCampusId } from "../globals";

/*
	Enlaces de los avisos de Cliq (Esteban, 2026-09-25): /enrollmentRequests?solicitud=27&plantel=4
	o /paymentIntents?ticket=21&plantel=4. Primero cambia al plantel del enlace (si la persona lo
	tiene), luego abre esa solicitud o ese ticket, y limpia la dirección para que al recargar no se
	vuelva a abrir. Igual que los enlaces de Horarios.
*/
export const useEnlaceDirecto = (param: string, abrir: (id: number) => void, avisar?: (texto: string) => void) => {
	const dispatch = useDispatch();
	const campusRef: any = useSelector((state: RootState) => state.campusRef.value);
	const currentUserCampus: any = useSelector((state: RootState) => state.currentUserCampus.value);
	const atendido = useRef(false);

	useEffect(() => {
		if (atendido.current || !campusRef || !currentUserCampus) {
			return;
		}
		const q = new URLSearchParams(window.location.search);
		const id = Number(q.get(param) || 0);
		const plantel = Number(q.get("plantel") || 0);
		if (!id && !plantel) {
			atendido.current = true;
			return;
		}
		if (plantel > 0 && campusRef[currentUserCampus]?.id !== plantel) {
			if (campusRef["C_" + plantel] == null) {
				atendido.current = true;
				window.history.replaceState(null, "", window.location.pathname);
				avisar?.("El enlace es de un plantel al que no tienes acceso.");
				return;
			}
			//Al cambiar el plantel este efecto vuelve a correr y ya abre lo enlazado.
			dispatch(setCurrentUserCampusId(plantel));
			dispatch(setCurrentUserCampus("C_" + plantel));
			return;
		}
		atendido.current = true;
		window.history.replaceState(null, "", window.location.pathname);
		if (id > 0) {
			abrir(id);
		}
	}, [campusRef, currentUserCampus]);
};

export default useEnlaceDirecto;
